import script from "./agreement.vue?vue&type=script&setup=true&lang=js"
export * from "./agreement.vue?vue&type=script&setup=true&lang=js"

import "./agreement.vue?vue&type=style&index=0&id=0ab82f21&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/staging-package-front-service/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ab82f21"]])

export default __exports__